import '../App.scss';

const SceneButton = (props: {text: string, onclick: (event: React.MouseEvent<HTMLDivElement>) => void}) => {
  return (
    <div className="button" onClick={props.onclick}>
      <div className="button-text">{props.text}</div>
    </div>
  )
}

export { SceneButton }